
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3.139 12.806a6.982 6.982 0 009.425-1.65l.14.945c.041.27.274.47.547.47h.081a.547.547 0 00.463-.62v-.005l-.448-3.028-2.867.706a.553.553 0 10.265 1.073l.97-.239A5.88 5.88 0 011.103 7.236a.552.552 0 00-1.102.047 7.009 7.009 0 003.138 5.523M.673 4.748l3.001-.654a.552.552 0 00-.208-1.083l-.027.006-.97.213a5.88 5.88 0 0110.37 3.087.552.552 0 00.548.489h.062a.552.552 0 00.485-.61A6.982 6.982 0 001.54 2.626l-.113-.937a.556.556 0 00-1.102.132l.349 2.926z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/start_over.svg